import { render, staticRenderFns } from "./Ranking&search.vue?vue&type=template&id=50e942ec&scoped=true"
import script from "./Ranking&search.vue?vue&type=script&lang=js"
export * from "./Ranking&search.vue?vue&type=script&lang=js"
import style1 from "./Ranking&search.vue?vue&type=style&index=1&id=50e942ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e942ec",
  null
  
)

export default component.exports